import React from 'react';
import {
  Router,
  Switch,
  BrowserRouter,
  Route,
  Redirect,
} from 'react-router-dom';
import Routes from './routes';
import history from './history';
// import NotFound from './pages/common/components/NotFound';
// import { GO_TO_DASHBOARD } from './pages/common/components/constants';
import {
  DASHBOARD_ROUTE,
  LOGGED_OUT_ONLINE_PAYMENTS,
  LOGGED_OUT_SUCCESS,
} from './constants/routes';
import LoggedOutOnlinePaymentsPage from './pages/Payments/LoggedOutOnlinePaymentsPage';
import LoggedOutPaymentSuccessPage from './pages/Payments/LoggedOutOnlinePaymentsPage/LoggedOutPaymentSuccessPage/LoggedOutPaymentSuccessPage';

const App = () => {
  return (
    <>
      <Router history={history}>
        <Switch>
          <BrowserRouter>
            <Switch>
              {/* <Route exact path={LANDING_ROUTE}>
                <NotFound showAction actionLabel={GO_TO_DASHBOARD} />
              </Route> */}
              <Route exact path={DASHBOARD_ROUTE}>
                <Routes />
              </Route>
              <Route exact path={LOGGED_OUT_ONLINE_PAYMENTS}>
                <LoggedOutOnlinePaymentsPage />
              </Route>
              <Route exact path={LOGGED_OUT_SUCCESS}>
                <LoggedOutPaymentSuccessPage />
              </Route>
              <Redirect to={DASHBOARD_ROUTE} />
            </Switch>
          </BrowserRouter>
        </Switch>
      </Router>
    </>
  );
};

export default App;
